import { useEffect } from 'react';
import { BlockDataForm } from '@plone/volto/components/manage/Form';
import PropTypes from 'prop-types';
import { defineMessages, useIntl } from 'react-intl';
import { v4 as uuid } from 'uuid';

import EventInfoSchema from './schema';

const messages = defineMessages({
  programming: {
    id: 'Programming',
    defaultMessage: 'Programming',
  },
  usefulInfo: {
    id: 'Useful Information',
    defaultMessage: 'Useful Information',
  },
  moreInfo: {
    id: 'More Information',
    defaultMessage: 'More Information',
  },
});

const EventInfoData = (props) => {
  const { data, block, onChangeBlock, blocksErrors } = props;
  const schema = EventInfoSchema({ ...props });
  const intl = useIntl();

  // Inicializa customSections apenas na primeira vez (quando o bloco é novo)
  useEffect(() => {
    if (
      !data.hasBeenEdited &&
      (!data.customSections || data.customSections.length === 0)
    ) {
      onChangeBlock(block, {
        ...data,
        hasBeenEdited: true,
        customSections: [
          {
            '@id': uuid(),
            title: intl.formatMessage(messages.programming),
            icon: 'fas fa-calendar',
          },
          {
            '@id': uuid(),
            title: intl.formatMessage(messages.usefulInfo),
            icon: 'fas fa-info-circle',
          },
          {
            '@id': uuid(),
            title: intl.formatMessage(messages.moreInfo),
            icon: 'fas fa-ellipsis-h',
          },
        ],
      });
    }
  }, [data, block, onChangeBlock, intl]);

  return (
    <BlockDataForm
      schema={schema}
      title={schema.title}
      onChangeBlock={onChangeBlock}
      onChangeField={(id, value) => {
        // Se o usuário editou customSections, marcar hasBeenEdited como true
        const updatedData = {
          ...data,
          [id]: value,
        };

        if (id === 'customSections') {
          updatedData.hasBeenEdited = true;
        }

        onChangeBlock(block, updatedData);
      }}
      formData={data}
      block={block}
      errors={blocksErrors}
    />
  );
};

EventInfoData.propTypes = {
  data: PropTypes.shape({
    size: PropTypes.string,
    spacing: PropTypes.string,
  }),
  block: PropTypes.string,
  onChangeBlock: PropTypes.func,
};

export default EventInfoData;
